<script setup lang="ts"></script>

<template>
  <div class="illustration">
    <svg xmlns="http://www.w3.org/2000/svg" width="202" height="156" viewBox="0 0 202 156" fill="none">
      <g>
        <path
          d="M39.1958 140.266H68.7595"
          stroke="currentColor"
          stroke-width="2.4318"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M50.5274 103.337C52.7822 102.066 54.9106 103.046 55.5674 105.461C56.1905 107.745 55.7849 109.948 54.8877 112.081C52.7416 117.198 49.4237 121.557 45.2373 125.313C44.6168 125.871 44.3742 126.343 44.5498 127.103C44.7257 127.864 44.7898 128.734 45.0225 129.519C45.4259 130.882 46.0883 131.201 47.4043 130.467C48.725 129.704 49.9801 128.842 51.1582 127.889C53.3898 126.16 55.5545 124.337 57.7627 122.562C57.9958 122.379 58.2441 122.213 58.5049 122.068C59.4124 121.542 60.3639 121.098 61.3799 121.749C62.4399 122.433 62.58 123.535 62.4405 124.614C62.2388 126.15 61.8919 127.672 61.6075 129.198L61.9385 129.464C62.8202 128.773 63.7485 128.128 64.5733 127.377C66.1946 125.896 67.7233 124.337 69.3575 122.875C70.4254 121.917 71.6152 120.901 73.2364 121.565C74.8572 122.229 74.6612 123.738 74.669 125.088V128.015L74.9922 128.242C76.1583 127.135 77.4075 126.098 78.4727 124.911C79.6724 123.572 80.6418 122.046 81.8467 120.712C82.3509 120.154 83.2584 119.507 83.8868 119.586C84.5151 119.665 85.1595 120.537 85.5137 121.202C85.992 122.1 86.1341 123.155 86.5323 124.101C87.6752 126.817 89.7545 127.693 92.5186 126.491C94.4673 125.642 96.2959 124.607 98.0411 123.456C98.636 124.312 99.3152 125.105 100.067 125.823C98.1151 127.118 96.0604 128.269 93.92 129.264C89.3148 131.398 85.9249 130.005 83.6856 125.592C83.5201 125.261 83.3495 124.933 83.1065 124.458C82.3075 125.375 81.6524 126.286 80.8301 127.027C79.3124 128.4 77.8287 129.875 76.086 130.944C73.6968 132.411 71.8816 131.437 71.5997 128.763C71.4859 127.669 71.5811 126.552 71.5811 125.155C70.6993 125.952 70.0061 126.588 69.3028 127.212C67.6981 128.64 66.089 130.063 64.4756 131.484C64.2181 131.701 63.9358 131.891 63.6348 132.049C62.3833 132.728 61.0928 133.437 59.6758 132.516C58.3085 131.627 58.3211 130.22 58.4581 128.842C58.5589 127.83 58.7584 126.824 58.9756 125.461C57.9414 126.318 57.1658 126.982 56.3643 127.624C54.2595 129.319 52.193 131.06 50.0235 132.672C48.6711 133.68 47.0394 134.213 45.3018 133.865C42.7601 133.358 42.1545 131.331 41.6348 129.291C41.5814 129.004 41.5439 128.714 41.5215 128.422C40.4357 129.077 39.4919 129.792 38.419 130.232C38.0975 130.347 37.7537 130.395 37.4112 130.375C37.0687 130.355 36.7341 130.268 36.4297 130.117C36.06 129.897 35.9594 129.035 36.0137 128.484C36.0499 128.128 36.5307 127.743 36.9004 127.497C38.3354 126.526 40.2749 125.884 41.1309 124.582C41.9532 123.326 41.5936 121.394 41.8858 119.779C42.7779 114.852 44.1845 110.081 47.3985 106.019C48.2525 104.943 49.3148 104.032 50.5274 103.337ZM51.9883 105.943C47.1558 109.84 46.0591 115.401 44.8877 120.932L45.2373 121.098C46.013 120.138 46.8639 119.214 47.5879 118.211C49.6824 115.312 51.7848 112.393 52.5528 108.862C52.7493 107.963 52.5831 106.992 52.5831 106.054L51.9883 105.943Z"
          fill="currentColor"
        />
        <path
          d="M141.808 63.8628L118.33 66.8124C117.409 67.1916 115.128 68.714 113.373 71.7695C108.031 81.0688 105.014 90.842 99.8828 100.131C99.3952 102.379 99.7528 106.664 105.084 105.819"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M114.673 94.605C114.673 94.605 117.513 82.903 120.768 81.6028C124.023 80.3026 127.68 81.6028 127.68 81.6028"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M150.826 66.8687C153.697 69.4149 162.573 75.9922 171.071 89.5663C177.328 99.5618 188.353 107.065 192.037 107.119"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M143.522 98.9115C144.768 96.582 147.996 86.1356 143.522 83.5526L139.296 81.521"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M149.372 99.3995C144.361 100.077 132.03 100.619 122.799 97.3679C111.259 93.3047 106.546 96.7991 105.652 103.869C104.758 110.939 127.349 111.995 133.607 115.571C139.864 119.147 139.945 119.065 146.528 123.616C153.11 128.167 164.081 129.874 169.363 129.467C173.589 129.142 178.167 132.366 179.927 134.018"
          stroke="currentColor"
          stroke-width="3.00594"
          stroke-linecap="round"
        />
        <path
          d="M108.095 107.607L103.625 120.609L117.765 111.67M127.355 98.6679L143.77 76.7672L170.425 41.6205L162.948 35.6069L117.765 94.9136"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M169.837 39.4654L171.439 37.3689C172.431 36.0703 172.182 34.2134 170.884 33.2212C169.585 32.2291 167.728 32.4775 166.736 33.7761L165.134 35.8726"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M118.563 110.154C117.628 112.595 116.835 117.161 120.277 118.567C124.09 120.125 127.288 117.632 128.534 113.893"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path
          d="M128.165 114.828C127.231 117.269 126.437 121.835 129.879 123.241C133.692 124.799 136.89 122.306 138.136 118.567"
          stroke="currentColor"
          stroke-width="3.00594"
        />
        <path d="M165.063 42.069L143.803 69.4243" stroke="currentColor" stroke-width="2.40475" stroke-linecap="round" />
      </g>
      <circle class="mark" cx="66.5" cy="54.5" r="30.5" stroke="currentColor" stroke-width="3" />
      <path
        class="mark"
        d="M57.2974 45.2969L76.2558 64.2553"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        class="mark"
        d="M57.302 64.2554L76.2604 45.2969"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.illustration {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: rgb(var(--v-theme-on-surface-high-xqes));
    width: 202px;
    height: 156px;

    // X mark over the figure — sits in the danger color, kept static so it stays
    // recognisable regardless of brand theming.
    .mark {
      color: rgb(var(--v-theme-danger-xqes));
    }
  }
}
</style>
